import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'partnership'
})
export class PartnershipPipe implements PipeTransform {

  transform(value: any, args?: any): any {
  	if(value = 'XS') return "8 Kits, 2 jaar";
  	if(value = 'S') return "12 Kits, 2 jaar";
  	if(value = 'M') return "24 Kits, 2 jaar";
  	if(value = 'L') return "30 Kits, 1 jaar";
    else return null;
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/partnership.pipe.ts